// src/components/sites/transfer/SupplierFormDialog.jsx
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	Box,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TransferItemRow } from "./TransferItemRow";

export function SupplierFormDialog({
	open,
	onClose,
	transferTypeLabels,
	users,

	// from useTransferForm
	transferForm,
	setTransferForm,
	submitting,
	error,
	setError,
	fromSiteOptionsFiltered,
	toSiteOptionsFiltered,
	getProductCatalogOptions,
	getProductOptions,
	addTransferItem,
	removeTransferItem,
	updateTransferItem,
	showFromSite,
	showToSite,
	showRestFields,
	renderDateLabel,
	submitTransfer,
	handleSiteChange,
	supplierList,
}) {
	const canRenderBody =
		transferForm.transfer_type &&
		transferForm.to_site_id &&
		(!showFromSite || transferForm.from_site_id) &&
		transferForm.supplier
		;
	const { transfer_type, from_site_id, to_site_id, supplier } = transferForm;
	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>{transferTypeLabels[transferForm.transfer_type]}</DialogTitle>

			<DialogContent>
				{showFromSite && (
					<TextField
						select
						fullWidth
						margin="dense"
						label="由地盤"
						value={from_site_id}
						onChange={(e) => handleSiteChange("from_site_id", e.target.value)}
					>
						{fromSiteOptionsFiltered.map((s) => (
							<MenuItem key={s.id} value={s.id}>
								{s.job_code} - {s.name}
							</MenuItem>
						))}
					</TextField>
				)}

				<TextField
					select
					fullWidth
					margin="dense"
					label="供應商"
					value={supplier}
					onChange={(e) =>
						setTransferForm((prev) => ({
							...prev,
							supplier: e.target.value,
						}))
					}
				>
					{supplierList.map((s) => (
						<MenuItem key={s} value={s}>
							{s}
						</MenuItem>
					))}
				</TextField>

				{showToSite && (
					<TextField
						select
						fullWidth
						margin="dense"
						label="選擇地盤"
						value={to_site_id}
						onChange={(e) => handleSiteChange("to_site_id", e.target.value)}
					>
						{toSiteOptionsFiltered.map((s) => (
							<MenuItem key={s.id} value={s.id}>
								{s.job_code} - {s.name} - {s.company_name}
							</MenuItem>
						))}
					</TextField>
				)}

				{canRenderBody && (
					<>
						<FormControl fullWidth margin="dense">
							<InputLabel>收貨負責人</InputLabel>
							<Select
								label="收貨負責人"
								value={transferForm.receiver ?? ""}
								onChange={(e) =>
									setTransferForm((prev) => ({
										...prev,
										receiver: e.target.value,
									}))
								}
							>
								{users.map((u) => (
									<MenuItem key={u.id} value={u.id}>
										{u.username || u.email}
									</MenuItem>
								))}
							</Select>
						</FormControl>


						<Box sx={{ mt: 1 }}>
							{transferForm.items.map((item, index) => (
								<TransferItemRow
									key={index}
									index={index}
									item={item}
									transferType={transferForm.transfer_type}
									getProductCatalogOptions={getProductCatalogOptions}
									getProductOptions={getProductOptions}
									updateItem={updateTransferItem}
									removeItem={removeTransferItem}
									canRemove={transferForm.items.length >= 2}
								/>
							))}
						</Box>

						<Button sx={{ mt: 1 }} onClick={addTransferItem}>
							新增貨物
						</Button>
						<Box sx={{ mt: 1 }}>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									label={renderDateLabel(transferForm.transfer_type)}
									format="YYYY/MM/DD"
									value={transferForm.expected_date || null}
									onChange={(newValue) =>
										setTransferForm((prev) => ({
											...prev,
											expected_date: newValue,
										}))
									}
									slotProps={{
										textField: { fullWidth: true, margin: "dense" },
									}}
								/>
							</LocalizationProvider>
						</Box>
						<TextField
							fullWidth
							margin="dense"
							label="備註(選填)"
							value={transferForm.remark || ""}
							onChange={(e) =>
								setTransferForm((prev) => ({
									...prev,
									remark: e.target.value,
								}))
							}
						/>
					</>
				)}

				{error && (
					<Typography color="error" sx={{ mt: 1 }}>
						{error}
					</Typography>
				)}
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose}>取消</Button>
				{transferForm.items.length ? (
					<LoadingButton
						variant="contained"
						onClick={submitTransfer}
						loading={submitting}
						disabled={!showRestFields}
					>
						確認
					</LoadingButton>) : ""}
			</DialogActions>
		</Dialog>
	);
}
